// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { withCallDeferredApi } from "@insite/client-framework/Components/DeferredApiContext";
import Zone from "@insite/client-framework/Components/Zone";
import { HideFooter, HideHeader } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import Page from "@insite/mobius/Page";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import {
    mapDispatchToPropsForProductList,
    mapStateToPropsForProductList,
    ProductListPage,
    ProductListPageDataContext,
} from "@werner/Overrides/Pages/ProductListPage";
import * as React from "react";
import { connect } from "react-redux";

export interface AllProductsPageStyle {}

const styles: AllProductsPageStyle = {};

class AllProductsPage extends ProductListPage {
    loadProducts() {
        const { displayProducts, search } = this.props;

        displayProducts({
            path: "",
            queryString: search,
            isSearch: false,
            includeProductsInSubCategories: true,
            restrictAttributesToCategory: false,
        } as any);
    }

    render() {
        if (
            this.props.productsDataView.value?.length &&
            this.props.productsDataView.exactMatch &&
            !this.props.stockedItemsOnly
        ) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        return (
            <Page>
                <CategoryContext.Provider value={this.props.category}>
                    <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                        <Modals />
                        <ProductCompareFlyOut />
                    </ProductListPageDataContext.Provider>
                </CategoryContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(
        mapStateToPropsForProductList,
        mapDispatchToPropsForProductList,
    )(withCallDeferredApi(withHistory(AllProductsPage))),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        supportsCategorySelection: true,
        pageType: "System",
        fieldDefinitions: [HideHeader, HideFooter],
    },
};
export default pageModule;

export const AllProductsPageContext = "AllProductsPage";
